module.exports = __webpack_public_path__ + "mapa1.74f3eaf2524cb6231061.png";


//////////////////
// WEBPACK FOOTER
// C:/Users/CLAUDIA/Desktop/Timeplacebook2/src/assets/img/mapa1.png
// module id = ../../../../../src/assets/img/mapa1.png
// module chunks = main